<template>
    <form v-show="isInputFormActive" method="POST">
        <div class="row d-flex align-items-end">
            <div class="col-lg-3 col-md-3 col-12">
                <div class="form-group">
                    <label for="itemname">{{ localizationStore.translate("select.bureau.required") }}</label>
                    <select v-model="selectedCreditBureauId" id="creditbureau" name="creditbureau" class="form-control"
                        :class="{'is-invalid' : creditBureauError}" required>
                        <option value="null">{{ localizationStore.translate("select.bureau") }}</option>
                        <option v-for="creditBureau in creditBureaus" v-bind:value="creditBureau.id">{{
                        creditBureau.name }}</option>
                    </select>
                    <span v-if="creditBureauError" class="invalid-feedback" role="alert">
                        <strong>Field is Required</strong>
                    </span>
                </div>
            </div>
        </div>

        <template v-for="(attribute, index) in formAttributes">
            <div class="row d-flex align-items-end">
                <div class="col-lg-3 col-md-3 col-12">
                    <div class="form-group">
                        <label for="name{{ index+1 }}">Old or Inaccurate Name {{ index+1 }}</label>
                        <input
                            v-model="formAttributes[index].name"
                            type="text"
                            class="form-control"
                            aria-describedby="name"
                            placeholder="Enter Old or Inaccurate Name"
                        />
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-12">
                    <div class="form-group">
                        <label for="address{{ index+1 }}">Old or Inaccurate Address {{ index+1 }}</label>
                        <input
                            v-model="formAttributes[index].address"
                            type="text"
                            class="form-control"
                            aria-describedby="address"
                            placeholder="Enter Old or Inaccurate Address"
                        />
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-12">
                    <div class="form-group">
                        <label for="employer{{ index+1 }}">Old or Inaccurate Employer {{ index+1 }}</label>
                        <input
                            v-model="formAttributes[index].employer"
                            type="text"
                            class="form-control"
                            aria-describedby="employer"
                            placeholder="Enter Old or Inaccurate Employer"
                        />
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-12">
                    <div class="form-group">
                        <button
                            @click="removeAttributes(index)"
                            type="button"
                            class="btn btn-outline-danger"
                        >
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        </template>
        <div class="row">
            <div class="col-12">
                <button
                    @click="addAttributes"
                    type="button"
                    class="btn btn-outline-primary btn-submit"
                >
                    Add
                </button>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-12">
                <a class="btn btn-primary btn-submit">Back</a>
                <button
                    @click="submitForm"
                    type="button"
                    class="btn btn-outline-primary btn-submit ml-1"
                >
                    Submit
                </button>
            </div>
        </div>
    </form>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12 px-0 px-md-1">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack">{{
                        localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <form :action="routes.createLetterRoute" method="post" enctype="multipart/form-data">
                            <input type="hidden" name="_token" :value="csrf">
                            <input
                                type="text"
                                class="form-control"
                                id="creditbureau"
                                name="creditbureau"
                                :value="selectedCreditBureauId"
                                hidden
                            >
                            <div class="col-md-12">
                                <div id="editor">
                                </div>
                                <div class="d-flex justify-content-center my-1">
                                    <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="1">
                                        {{ localizationStore.translate("letter.left.submit.button.text") }}
                                    </button>
                                    <button
                                        class="btn btn-outline-primary ml-1"
                                        @click="$refs.spinner.spinLetter()"
                                        type="button"
                                    >
                                        {{ localizationStore.translate("spin.letter.button.text") }}
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRef' />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div ref="editorRef" hidden>
            <div class="page">
    
                <strong>Date:</strong> {{ userInfo.tdate }}
                <br />
                <br />
                <p>
                    <template v-if="isCreditBureauSelected">
                        {{ selectedCreditBureau.address_name }} <br />
                        {{ selectedCreditBureau.street_address }} <br />
                        {{ selectedCreditBureau.city }}, {{ selectedCreditBureau.state_abbrev }}
                        {{ selectedCreditBureau.zipcode }}
                    </template>
                </p>
                <p>
                    <template v-if="isCreditBureauSelected">
                        <strong>Attn:</strong> {{selectedCreditBureau.officers}} <br />
                    </template>
                </p>
                <p>
                    <strong>RE:</strong> Dispute of Personal Identifier Information; Request for Deletion
                </p>
                <p>
                    Notice, I <strong><u>DEMAND</u></strong> that you permanently and completely eradicate from your
                    reports any alleged personal identifier information as I do <strong>NOT AUTHORIZE</strong> you
                    nor any other entity rights to retain or report any of my <strong>nonpublic personal
                    information</strong> data that is one or more of following:
                    <strong> being untrue, incorrect, incomplete, not requisite reported,
                        untimely, outdated, unverified, invalid, lacking maximum accuracy and completeness or else
                        wise deficient of documentary proof of factual certification
                        of compliant reporting to include to the perfect and complete mandatory
                        Metro 2 format reporting standards.
                    </strong>
                </p>
                <p class="letter-content">
                    I recently reviewed the consumer report that you've published that
                    allegedly concerns personal identifier information about me.
                    After careful review of your published consumer reports, it has come to my
                    awareness that the alleged information that is being reported is
                    [“inaccurate” or “incomplete” or “inaccurate and incomplete”]. It also may be
                    mixed or merged with another consumer’s information. Such conduct nonetheless is causing
                    me tremendous harm both financially and emotionally.
                </p>
                <p>
                    My current true correct full legal FIRST and LAST name is and ONLY is: <strong>{{ userInfo.firstname
                    }} {{ userInfo.lastname }}</strong>
                    <br />
                    My true Date of birth is: <strong>{{ userInfo.dob }} </strong>
                    <br />
                    My current true correct address street NUMBER and street NAME is and ONLY is: <strong>{{
                    userInfo.address }} </strong>
                    <br />
                    My current true correct CITY and STATE is and ONLY is: <strong>{{ userInfo.city }}, {{
                    userInfo.state }}</strong>
                    <br />
                    My current true correct legal last four of Social Security Number is and ONLY is: {{userInfo.ssn}}
                </p>
    
                <p class="letter-content">
                    I request that you <strong><u>DELETE</u></strong> the below-listed alleged <strong>[names, addresses,
                    and employers]</strong> from my credit file and send me an updated copy of my file with the information removed. I also
                    request that you notify any person or company with whom you have shared this
                    information that it has been deleted. If you do however conclude that the above
                    personal identifier Information is verified, I request that you provide me with details and methods
                    on how you verified this alleged information.
                </p>
                <template v-if="formAttributes.find((attribute) => { return attribute.name != null;})">
                    The following alleged <strong>name(s)</strong> you are publishing about me is [“inaccurate”
                    or “incomplete” or “inaccurate and incomplete”]:
                    <ol>
                        <template v-for="attribute in formAttributes">
                            <li v-if="attribute.name">
                                <strong>{{ attribute.name }}</strong>
                            </li>
                        </template>
                    </ol>
                </template>
                <template v-if="formAttributes.find((attribute) => { return attribute.address != null;})">
                    The following alleged <strong>addresses</strong> you are publishing about me is [“inaccurate”
                    or “incomplete” or “inaccurate and incomplete”]:
                    <ol>
                        <template v-for="attribute in formAttributes">
                            <li v-if="attribute.address">
                                <strong>{{ attribute.address }}</strong>
                            </li>
                        </template>
                    </ol>
                </template>
                
                <template v-if="formAttributes.find((attribute) => { return attribute.employer != null;})">
                    The following alleged <strong>employer(s)</strong> you are publishing about me is [“inaccurate”
                    or “incomplete” or “inaccurate and incomplete”]:
                    <ol>
                        <template v-for="attribute in formAttributes">
                            <li v-if="attribute.employer">
                                <strong>{{ attribute.employer }}</strong>
                            </li>
                        </template>
                    </ol>
                </template>
    
                <p class="letter-content">
                    I do NOT wish to disclose ANY EMPLOYERS, unless you
                    can produce or present to me legally authorized and verifiable evidence to retain
                    much less report these Employers I DEMAND THAT YOU DELETE THEM FROM MY CONSUMER
                    CREDIT REPORT. Otherwise you are infringing my consumer rights.
                </p>
                <p class="letter-content">
                    Since it appears that you do not have reasonable procedures in place to
                    assure maximum accuracy and/or completeness of the information
                    in your consumer reports concerning me, I request that any future reporting about me must be sent to me first for my review
                    before you prepare and publish any information in a consumer report concerning me directly or inderictly.
                    <br>
                    <br>
                    Enclosed are copies of ID and proof of mailing address.
                </p>
                <p style="page-break-after: always;" class="letter-content">
                    Regards, <br /> <br />
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                </p>
            </div>
            <div class="page-content">
                <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
                <p style="padding-top:3rem; text-align: center;">
                    <img v-if='userInfo.ssn_image_url' v-bind:src='userInfo.ssn_image_url' width='300' height='200' />
                    <img v-if='userInfo.identity_image_url' v-bind:src='userInfo.identity_image_url' width='300'
                        height='200' />
                </p>
                <p v-if='userInfo.address_verify_image_url'>
                    <img v-bind:src='userInfo.address_verify_image_url' width='300' height='200' />
                </p>
            </div>
        </div>
    </section>
</template>
<script>
import { reactive, computed } from 'vue'
import { ref } from 'vue'
import { useLocalizationStore } from '../../stores/LocalizationStore.js'
export default {
    props: {
        csrf: {
            type: String
        },
        creditBureaus: {
            type: [Array, Object]
        },
        userInfo: {
            type: [Array, Object]
        },
    },
    components: {
    },
    data() {
        return {
            formAttributes: [{
                name: null,
                address: null,
                employer: null
            }]
        }
    },
    setup(props) {
        const localizationStore = useLocalizationStore();
        // const formAttributes = reactive([reactive(attributes)]);
        const selectedCreditBureauId = ref(null),
            editorRef = ref(null),
            isInputFormActive = ref(true),
            creditBureauError = ref(false);
        return {
            // formAttributes,
            selectedCreditBureauId,
            editorRef,
            isInputFormActive,
            creditBureauError,
            localizationStore
        };
    },
    created() {
    },
    mounted() {
    },
    beforeCreate() {
    },
    computed: {
        // a computed getter
        selectedCreditBureau() {
            return this.creditBureaus.find((attribute) => {
                if (attribute.id == this.selectedCreditBureauId) {
                    return attribute;
                }
            })
        },
        isCreditBureauSelected() {
            return (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") ? false : true;
        }
    },
    methods: {
        submitForm: function () {
            if (this.validate()) {
                setTimeout(() => {
                    tinymce.get('editor').setContent(this.editorRef.innerHTML);
                    this.isInputFormActive = !this.isInputFormActive;
                }, "100");
            }
        },
        goBack: function () {
            this.isInputFormActive = !this.isInputFormActive;
        },
        validate: function () {
            if (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") {
                this.creditBureauError = true;
            }
            else {
                this.creditBureauError = false;
            }
            return !this.creditBureauError;
        },
        addAttributes: function () {
            this.formAttributes.push({
                name: null,
                address: null,
                employer: null
            });
        },
        removeAttributes: function (index) {
            const attributes = _.filter(this.formAttributes, function(attribute, key) {
                if (index != key) {
                    return attribute;
                }
            });
            // this.formAttributes.length = 0;
            this.formAttributes = attributes;
        }
    }
};
</script>
